import React from "react";

const AppFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer app-widget-panel" aria-label="Application footer">
      <div className="app-footer__content">
        <span className="app-footer__brand">Limitless FX</span>
        <span className="app-footer__meta">Algo Performance Dashboard</span>
      </div>
      <div className="app-footer__content app-footer__content--right">
        <span className="app-footer__meta">© {currentYear}</span>
      </div>
    </footer>
  );
};

export default AppFooter;
